export const mappingToFormEmpty = (keys) =>
  keys.map((name) => ({
    name,
    mapping: {
      operation: 'default',
      default_value: '',
      target1: '',
      target2: '',
      separator: '',
      index: 0,
    },
  }));
